export const getLoyaltyConfig = async (loyaltySdk) => {
  try {
    return await loyaltySdk.getConfig();
  } catch (error) {
    return null;
  }
};

export const hasBenefitAccess = async (loyaltySdk, benefitType) => {
  if (!loyaltySdk) {
    return false;
  }
  try {
    const currentTierId = await loyaltySdk.getCustomerTierId();
    return await loyaltySdk.isBenefitAvailableForTier(
      currentTierId,
      benefitType
    );
  } catch (error) {
    return false;
  }
};

export const getBenefitTypeConfig = (loyaltyConfig, benefitType) => {
  return (
    loyaltyConfig?.benefits?.find((item) => item.type === benefitType) ?? null
  );
};
